// extracted by mini-css-extract-plugin
module.exports = {"Calculators":"calculators_Calculators__1pKXa","p":"calculators_p__3XkyK"};